import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import IconInfo from '@/icons/Info.svg';
import IconPayment from '@/icons/Payment.svg';
import { RequestWithRelations } from '@/models/request';
import { hasPermission } from '@/models/user';
import { useCurrentSession } from '@/services/auth';

export const RefundStepMessage = ({ request }: { request: RequestWithRelations }) => {
  const { currentSession } = useCurrentSession();

  if (
    !hasPermission(currentSession, 'validate_payment', {
      organizationId: request.organizationId,
      entityId: request.storeId,
    })
  ) {
    return (
      <AlertBar
        type="info"
        size="large"
        icon={<IconInfo />}
        title={
          <Trans id="article.step.refund.external-refund-message.unauthorized.title">
            Waiting for refund information
          </Trans>
        }
      >
        <Trans id="article.step.refund.external-refund-message.unauthorized.text">
          Someone will provide the required refund details to validate the step
        </Trans>
      </AlertBar>
    );
  }

  return (
    <AlertBar
      type="warning"
      size="large"
      icon={<IconPayment />}
      title={
        <Trans id="article.task.validate-external-refund.title">
          Waiting for refund information
        </Trans>
      }
    >
      <Trans id="article.task.validate-external-refund.message">
        Please provide the required refund details on the request page to validate the step
      </Trans>
    </AlertBar>
  );
};
